import { render, staticRenderFns } from "./resource-card.vue?vue&type=template&id=55385c70&"
import script from "./resource-card.ts?vue&type=script&lang=ts&"
export * from "./resource-card.ts?vue&type=script&lang=ts&"
import style0 from "./resource-card.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports